{
  "$extensions": {
    "com.figma.modeName": "Dark"
  },
  "Background": {
    "Page": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.07058823529411765,
          0.07058823529411765,
          0.07058823529411765
        ],
        "alpha": 1,
        "hex": "#121212"
      }
    },
    "Subtle": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.11764705882352941,
          0.12156862745098039,
          0.13725490196078433
        ],
        "alpha": 1,
        "hex": "#1E1F23"
      }
    },
    "Raised": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.17254901960784313,
          0.17647058823529413,
          0.20392156862745098
        ],
        "alpha": 1,
        "hex": "#2C2D34"
      }
    }
  },
  "Text": {
    "Primary": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.9803921568627451,
          0.9803921568627451
        ],
        "alpha": 1,
        "hex": "#FAFAFA"
      }
    },
    "Secondary": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.592156862745098,
          0.6,
          0.6392156862745098
        ],
        "alpha": 1,
        "hex": "#9799A3"
      }
    },
    "Disabled": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4,
          0.40784313725490196,
          0.4549019607843137
        ],
        "alpha": 1,
        "hex": "#666874"
      }
    }
  },
  "State": {
    "Selected": {
      "Container": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.10588235294117647,
            0,
            0.37254901960784315
          ],
          "alpha": 1,
          "hex": "#1B005F"
        }
      }
    },
    "Disabled": {
      "Container": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.17254901960784313,
            0.17647058823529413,
            0.20392156862745098
          ],
          "alpha": 1,
          "hex": "#2C2D34"
        }
      }
    },
    "Error": {
      "Container": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.25098039215686274,
            0,
            0.10588235294117647
          ],
          "alpha": 1,
          "hex": "#40001B"
        }
      },
      "Border": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.8392156862745098,
            0.23921568627450981,
            0.4745098039215686
          ],
          "alpha": 1,
          "hex": "#D63D79"
        }
      },
      "Text": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            1,
            0.5411764705882353,
            0.6941176470588235
          ],
          "alpha": 1,
          "hex": "#FF8AB1"
        }
      }
    }
  },
  "Border": {
    "Subtle": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.11764705882352941,
          0.12156862745098039,
          0.13725490196078433
        ],
        "alpha": 1,
        "hex": "#1E1F23"
      }
    },
    "Default": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4,
          0.40784313725490196,
          0.4549019607843137
        ],
        "alpha": 1,
        "hex": "#666874"
      }
    },
    "Strong": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4,
          0.40784313725490196,
          0.4549019607843137
        ],
        "alpha": 1,
        "hex": "#666874"
      }
    }
  },
  "Action": {
    "Primary": {
      "Subtle": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.10588235294117647,
            0,
            0.37254901960784315
          ],
          "alpha": 1,
          "hex": "#1B005F"
        }
      },
      "SubtleHover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.1568627450980392,
            0,
            0.5176470588235295
          ],
          "alpha": 1,
          "hex": "#280084"
        }
      },
      "Border": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.3254901960784314,
            0.30196078431372547,
            0.8823529411764706
          ],
          "alpha": 1,
          "hex": "#534DE1"
        }
      },
      "Default": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.4,
            0.4117647058823529,
            0.984313725490196
          ],
          "alpha": 1,
          "hex": "#6669FB"
        }
      },
      "Hover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.4980392156862745,
            0.5490196078431373,
            1
          ],
          "alpha": 1,
          "hex": "#7F8CFF"
        }
      },
      "Pressed": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.6235294117647059,
            0.6823529411764706,
            1
          ],
          "alpha": 1,
          "hex": "#9FAEFF"
        }
      },
      "Text": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.7764705882352941,
            0.8196078431372549,
            1
          ],
          "alpha": 1,
          "hex": "#C6D1FF"
        }
      }
    },
    "Secondary": {
      "Subtle": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.1411764705882353,
            0.12549019607843137,
            0
          ],
          "alpha": 1,
          "hex": "#242000"
        }
      },
      "SubtleHover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.20784313725490197,
            0.1803921568627451,
            0
          ],
          "alpha": 1,
          "hex": "#352E00"
        }
      },
      "Border": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.47843137254901963,
            0.40784313725490196,
            0
          ],
          "alpha": 1,
          "hex": "#7A6800"
        }
      },
      "Default": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.5882352941176471,
            0.4980392156862745,
            0
          ],
          "alpha": 1,
          "hex": "#967F00"
        }
      },
      "Hover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.7098039215686275,
            0.592156862745098,
            0
          ],
          "alpha": 1,
          "hex": "#B59700"
        }
      },
      "Pressed": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.8392156862745098,
            0.6941176470588235,
            0
          ],
          "alpha": 1,
          "hex": "#D6B100"
        }
      },
      "Text": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.9490196078431372,
            0.8196078431372549,
            0.38823529411764707
          ],
          "alpha": 1,
          "hex": "#F2D163"
        }
      }
    }
  }
}